export default __webpack_public_path__ + "static/media/sched.09de9654.png";